import { Tabs } from "@design-system/Tabs/Tabs";
import { useScheduleHubCopy } from "./ScheduleHubScopeProvider";

export const SCHEDULES_HUB_TABS = {
    policies: "policies",
    schedules: "schedules",
} as const;

export type SchedulesHubTab =
    (typeof SCHEDULES_HUB_TABS)[keyof typeof SCHEDULES_HUB_TABS];

export function isSchedulesHubTab(
    value: string | null | undefined,
): value is SchedulesHubTab {
    return (
        value === SCHEDULES_HUB_TABS.policies ||
        value === SCHEDULES_HUB_TABS.schedules
    );
}

interface SchedulesHubTabsProps {
    activeTab: SchedulesHubTab;
    onTabChange: (tab: SchedulesHubTab) => void;
}

export const SchedulesHubTabs = ({
    activeTab,
    onTabChange,
}: SchedulesHubTabsProps) => {
    const { schedulesTabLabel } = useScheduleHubCopy();
    return (
        <Tabs.Root
            value={activeTab}
            onValueChange={(value) => {
                if (isSchedulesHubTab(value)) {
                    onTabChange(value);
                }
            }}
        >
            <Tabs.List>
                <Tabs.Tab value={SCHEDULES_HUB_TABS.policies}>
                    Policies
                </Tabs.Tab>
                <Tabs.Tab value={SCHEDULES_HUB_TABS.schedules}>
                    {schedulesTabLabel}
                </Tabs.Tab>
            </Tabs.List>
        </Tabs.Root>
    );
};
